module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/36293908f24bed21ed15400c3ab3e1b8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_up_solid.svg
// module id = kPzT
// module chunks = 0